import { Alert, Card, Spin } from "antd";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { DynamicSubmissionForm } from "./DynamicSubmissionForm";

const FormHandler = ({ user }: { user: any }) => {
	const { id } = useParams();
	const [formData, setFormData] = useState<any>(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);

	// Use refs to prevent infinite re-renders
	const loadingRef = useRef(false);
	const lastRequestRef = useRef<string>("");

	// Extract stable values to prevent unnecessary re-renders
	const orgId = user?.organization?.id;

	useEffect(() => {
		const loadFormData = () => {
			if (!id || !user?.organization) {
				setError("Missing form ID or user organization");
				setLoading(false);
				return;
			}

			// Create a unique key for this request
			const requestKey = `${id}-${orgId}`;

			// Prevent duplicate processing
			if (lastRequestRef.current === requestKey) {
				return;
			}

			try {
				lastRequestRef.current = requestKey;
				setLoading(true);
				setError(null);

				// Find the form in the user's organization forms
				const form = user.organization.forms.find((f: any) => {
					// Try to match by different possible ID fields
					return (
						f.id === Number(id) ||
						f.form_id === Number(id) ||
						f.formId === Number(id)
					);
				});

				if (!form) {
					setError(`Form ${id} not found in your current organization.`);
					setLoading(false);
					return;
				}
				setFormData(form);
				setLoading(false);
			} catch (err) {
				setError("Failed to load form data");
				setLoading(false);
			}
		};

		loadFormData();
	}, [id, orgId, user?.organization?.forms]);

	if (loading) {
		return (
			<div style={{ padding: "20px" }}>
				<Card>
					<div style={{ textAlign: "center", padding: "50px" }}>
						<Spin size="large" />
						<p style={{ marginTop: "16px" }}>Loading form...</p>
					</div>
				</Card>
			</div>
		);
	}

	if (error) {
		return (
			<div style={{ padding: "20px" }}>
				<Card>
					<Alert
						message="Error Loading Form"
						description={error}
						type="error"
						showIcon
					/>
				</Card>
			</div>
		);
	}

	// Pass the form data and user to DynamicSubmissionForm
	return <DynamicSubmissionForm user={user} formData={formData} formId={id} />;
};

export { FormHandler };
